import { ValidationResult } from '../../../../../../ui/gzForm/formField/types/form-validator';

function hasValidWildcardSyntax(value: string, invalidSubstrings: string[], error: string): ValidationResult {
  if (invalidSubstrings.some(substring => value.includes(substring))) {
    return {
      valid: false,
      error: error,
    };
  }

  // when path contains ? or * but inside a system variable, then this is invalid, this wildcard is considered invalid
  if (value.match(/%[a-zA-Z]*[?*]+[a-zA-Z]*%/)) {
    return {
      valid: false,
      error: error,
    };
  }

  return { valid: true };
}

export function wildcard(value: string, error: string): ValidationResult {
  const invalidSubstrings = ['**', '*?', '?*', '[', ']'];
  return hasValidWildcardSyntax(value, invalidSubstrings, error);
}

export function wildcardWithAny(value: string, error: string): ValidationResult {
  const invalidSubstrings = ['***', '*?', '?*', '[', ']'];
  return hasValidWildcardSyntax(value, invalidSubstrings, error);
}
